export const PAYMENT_METHODS = {
  APPLE_PAY: "applePay",
  CARD: "card",
  KLARNA: "klarna",
  PAYPAL: "paypal",
  SEPA: "sepa",
  PARTNER_CARD: "partner_card",
}

export const supportedPaymentMethodsOrder = [
  PAYMENT_METHODS.PARTNER_CARD,
  PAYMENT_METHODS.KLARNA,
  PAYMENT_METHODS.APPLE_PAY,
  PAYMENT_METHODS.PAYPAL,
  PAYMENT_METHODS.CARD,
]
